import { TemplateNavHeaderStyles } from "./NavHeader.styles"

const t = document.createElement('template')
t.innerHTML = `
<wa-tab class="nav-item border-bottom border-2 border-primary">
  <slot></slot>
</wa-tab>
`

class NavHeaderPrimaryLink extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderPrimaryLink connectedCallback', this)
  }
}

if (!customElements.get('ts-navheader-primary-link')) {
  customElements.define('ts-navheader-primary-link', NavHeaderPrimaryLink)
}
export { NavHeaderPrimaryLink }
